<template>
  <div class="dictionary">
    <div
      v-if="mNavBack && showMNavBack"
      class="m-nav-back"
      @click="mNavBack = false"
    >
      <svg width="20" height="20" class="m-nav-back__arrow">
        <use xlink:href="#chevron" />
      </svg>
    </div>

    <dictionary-search
      :class="{m_show: !mNavBack}"
      :terms="terms"
      :currentTermName="currentTermName"
      :currentRequest="currentRequest"
      :noteName="noteName"
      @on-submit="onSubmit"
      @term-selected="handleTermSelected"
      @clean-query-text="cleanQueryText"
    />

    <dictionary-term
      v-if="currentTermName"
      :term="currentTermInfo"
      :noteTerm="termError"
      :loading="termLoading"
      :_class="mNavBack ? 'm_show' : ''"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DictionarySearch from './DictionarySearch';
import DictionaryTerm from './DictionaryTerm';

export default {
  components: {
    DictionarySearch,
    DictionaryTerm
  },

  data() {
    return {
      noteName: '',
      mNavBack: false
    };
  },

  computed: {
    ...mapGetters({
      currentRequest: 'currentRequest',
      currentTermName: 'currentChoice',
      terms: 'currentTerms',
      currentTermInfo: 'currentTermInfo',
      termLoading: 'termInfoLoading',
      termError: 'termInfoError',
      winSize: 'getWindowSize'
    }),
    showMNavBack() {
      return this.winSize < 720;
    }
  },

  async created() {
    if(this.$route.query && ('term' in this.$route.query)) {
      await this.getTermAndDefinitions(this.$route.query.term)
    }
  },

  watch: {
    $route: async function(to, from) {
      let requestTo = (to.query && to.query.term)? to.query.term: ''
      let requestFrom = (from.query && from.query.term)? from.query.term: ''
      
      if(requestTo !== requestFrom){
        await this.getTermAndDefinitions(requestTo)       
      }
    }
  },

  methods: {
    async onSubmit(name) {
      this.noteName = '';
      if (name.length < 3) {
        this.noteName = name
          ? 'Строка поиска терминов должна содержать не менее трех символов'
          : 'Введите, пожалуйста, подстроку для поиска терминов (не менее трех символов)';
        this.$refs.searchTermInput.focus();

        return;
      }
      await this.getTermAndDefinitions(name)
      this.$router.push({
        query:{
          term: name
        }
      }).catch(err => {}) // To remove error on navigation on the same page
    },
    async getTermAndDefinitions(name){
      await this.$store.dispatch('getDictionaryList', name);

      if (this.terms.length) {
        await this.$store.dispatch('getDictionaryItemInfo', this.terms[0].name);
      } else {
        await this.$store.dispatch('getDictionaryItemInfo', '');
        this.noteName = `Термины по подстроке «${name}» не найдены`;
      }
    },
    async cleanQueryText() {
      await this.$store.dispatch('getDictionaryList', '');
      await this.$store.dispatch('getDictionaryItemInfo', '');
    },
    handleTermSelected(term) {
      this.mNavBack = true;
      this.$store.dispatch('getDictionaryItemInfo', term.name);
    }
  },

  metaInfo() {
    return {
      title: this.currentTermName
        ? `Термин: ${this.currentTermName}`
        : 'Словарь'
    };
  }
};
</script>

<style src="./styles/index.css" />
